import React, { useEffect } from "react";
import { GameLayout } from "./GameLayout";
import { GameNavigator } from "./GameNavigator";
import { GameMain } from "./Main/GameMain";
import { GameHeader } from "./GameHeader";
import { useGameContext } from "./Hook/GameContext";
import { GamePage } from "./Hook/useGame";
import { GameLobby } from "./Lobby/GameLobby";
import { GameMyPage } from "./MyPage/GameMyPage";
import { GameRank } from "./Rank/GameRank";
import GameDialog from "./Component/Dialog";
import RankingDialog from "./Component/RankingDialog";
import { GameInfoDialog } from "./Component/GameInfoDialog";
import { AttendanceDialog } from "./Component/attendanceDialog";
import GameCouponDialog from "./Component/CouponDialog";
import { GameClub } from "./Club/GameClub";
import { GameClubProvider, useGameClubContext } from "./Hook/GameClubContext";
import { freeCharge } from "../../../api/game";
import { LOCAL_STORAGE_ACCESS_KEY } from "../../../utils/network";
import { ClubDialog } from "./Component/clubDialog";
import { enqueueSnackbar } from "notistack";
import { GameTab } from "./Hook/useGameAction";
import { ClubTab } from "./Hook/useGameClub";
import { GameRNG } from "./GameRNG";
import { getClubUserState } from "../../../api/game-club";

const GameContent: React.FC = () => {
  const {
    history,
    gamePageState,
    dialogState,
    isRankingDialogOpen,
    gameInfoData,
    dailyAttendanceCheck,
    attendanceList,
    setAttendanceList,
    couponDialogState,
    checkIsValidate,
    openDialog,
    showGNB,
    getUserTicket,
    isClubDialog,
    setIsClubDialog,
    isFirstVisit,
    setIsFirstVisit,
    setGamePageState,
    setGameTab,
    isRng,
  } = useGameContext();

  const attendanceCheck = async () => {
    const data = await dailyAttendanceCheck();
    if (data) setAttendanceList(data);
  };

  const moveToRingGameListPage = () => {
    setGamePageState(GamePage.GAME);
    setGameTab(GameTab.HOLDEM);
  };

  const moveToClubChatPage = () => {
    setGamePageState(GamePage.CLUB);
  };

  const clubDialogCheck = async () => {
    if (!isFirstVisit) return;
    const token = localStorage.getItem(LOCAL_STORAGE_ACCESS_KEY);
    const accessToken = token ? token.replace("Bearer ", "") : "-";
    const res = await getClubUserState(accessToken);
    setIsFirstVisit(false);
    if (res.result === -10) {
      setIsClubDialog(true);
    }
  };

  const moveToPage = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const page = urlParams.get("page");
    if (page === "ring") {
      moveToRingGameListPage();
      openDialog({
        text: `러너 홀덤 게임에서 \n 계속 도전하세요!`,
        buttonText: "확인",
      });
    }
    if (page === "club-chat") {
      moveToClubChatPage();
    }
  };

  useEffect(() => {
    checkIsValidate();
    attendanceCheck();
    moveToPage();
  }, []);

  const getFreeCharge = async () => {
    const token = localStorage.getItem(LOCAL_STORAGE_ACCESS_KEY);
    const accessToken = token ? token.replace("Bearer ", "") : "-";
    if (token) {
      const res = await freeCharge(accessToken);
      if (res.data.result === -4) {
        enqueueSnackbar(
          "게임 데이터 이전 작업 중입니다. 잠시 후 다시 접속해주세요.(최대 5분 소요)",
          {
            variant: "warning",
          }
        );
        history.replace("/");
      }
      if (res.data.result !== 1) return;
      if (res.data.payload.freeCharge.chargedThisTime) {
        openDialog({
          text: `무료 충전 \n ${res.data.payload.freeCharge.chargedPoint.toLocaleString()}GP를 받으셨어요👏 \n(${
            res.data.payload.freeCharge.usedCount
          }/${res.data.payload.freeCharge.maxCount})`,
          buttonText: "확인",
        });
      }
      if (res.data.payload.newUserBonus) {
        openDialog({
          text: `신규 가입 리워드 \n ${res.data.payload.newUserBonus.toLocaleString()}GP를 받으셨어요👏`,
          buttonText: "확인",
        });
      }
      if (res.data.payload.oldRecommendReward) {
        openDialog({
          text: `친구 추천 리워드 \n ${res.data.payload.oldRecommendReward.point.toLocaleString()}GP를 받으셨어요👏`,
          buttonText: "확인",
        });
      }
      if (res.data.payload.newRecommendReward) {
        openDialog({
          text: `친구 추천 리워드 \n ${res.data.payload.newRecommendReward.toLocaleString()}GP를 받으셨어요👏`,
          buttonText: "확인",
        });
      }
      await getUserTicket();
    }
  };

  useEffect(() => {
    getFreeCharge();
  }, []);
  useEffect(() => {
    const handlePopState = (event: PopStateEvent) => {
      // 뒤로가기 버튼이 눌렸을 때
      event.preventDefault();
      openDialog({
        text: `게임을\n그만하시겠습니까?`,
        buttonText: "퇴장하기",
        onConfirm: () => {
          history.replace("/");
        },
      });
      window.history.pushState(null, "", window.location.href);
    };

    window.history.pushState(null, "", window.location.href);

    window.addEventListener("popstate", handlePopState);
    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, [history]);
  return (
    <>
      {isRng ? (
        <GameRNG />
      ) : (
        <GameLayout>
          {gamePageState === GamePage.MAIN && <GameMain></GameMain>}
          {gamePageState === GamePage.RANKING && <GameRank></GameRank>}
          {gamePageState === GamePage.MY_PAGE && <GameMyPage></GameMyPage>}
          {gamePageState === GamePage.GAME && <GameLobby></GameLobby>}
          {gamePageState === GamePage.CLUB && (
            <GameClubProvider>
              <GameClub></GameClub>
            </GameClubProvider>
          )}
          <GameHeader></GameHeader>
          {showGNB && <GameNavigator></GameNavigator>}
          {couponDialogState && <GameCouponDialog data={couponDialogState} />}
          {dialogState && <GameDialog data={dialogState} />}
          {isRankingDialogOpen && <RankingDialog />}
          {gameInfoData && <GameInfoDialog />}
          {attendanceList.length > 0 && <AttendanceDialog />}
          {isClubDialog && <ClubDialog />}
        </GameLayout>
      )}
    </>
  );
};

export default GameContent;
